export enum UserPermissionGroup {
  Admin = "admin-group",
  Default = "default-group",
}
